<template>
  <v-card
    style="border-radius: 10px; overflow: hidden"
    class="card ma-1 ntn_message-card"
    :style="{ width: size == 'big' ? '300px' : '200px' }"
  >
    <template v-if="ntn_message.image_url">
      <div
        class="card-img"
        :style="{
          height: (size == 'big' ? '300' : '200') / (ratio == 'horizontal' ? 1.91 : 1) + 'px'
        }"
        style="border-bottom: 1px solid #eee"
      >
        <div
          :style="{
            height: (size == 'big' ? '300' : '200') / (ratio == 'horizontal' ? 1.91 : 1) + 'px',
            'background-image': 'url(\'' + ntn_message.image_url + '\')'
          }"
          style="
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          "
        ></div>
      </div>
    </template>
    <div
      class="card-body"
      style="padding: 0px 8px; overflow: hidden"
      :style="{ height: size == 'small' ? '120px' : '120px' }"
    >
      <h4
        style="font-weight: 600; margin: 10px 0px"
        :style="{ 'font-size': size == 'big' ? 'inherit' : '12px' }"
      >
        <template v-if="ntn_message.title">
          <specialtext :text="ntn_message.title"></specialtext>
        </template>
        <template v-else>&nbsp;</template>
      </h4>
    </div>

    <div class="card-footer">
      <ul class="list-group list-group-flush" style="margin-bottom: 0px">
        <li
          class="list-group-item"
          style="border: none; border-top: 1px solid #eee; border-radius: 0px; text-align: center"
          :style="{ padding: size == 'small' ? '5px 0' : '10px 0' }"
        >
          <span style="color: #0084ff">
            <span
              v-if="!isBotTest"
              v-clipboard:copy="ntn_message.notification_messages_frequency"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
              style="cursor: pointer"
            >
              <!-- {{ ntn_message.notification_messages_frequency }} -->
              {{ $t('receive_messages_every_day') }}
            </span>
            <span v-else style="cursor: pointer" @click="btnClick(ntn_message)">
              <!-- {{ ntn_message.notification_messages_frequency }} -->
              {{ $t('receive_messages_every_day') }}
            </span>
          </span>
        </li>
      </ul>
    </div>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Copied') }}!</v-snackbar
    >
  </v-card>
</template>

<script>
import specialtext from '@/components/elements/specialtext'
import { mapGetters } from 'vuex'

export default {
  components: {
    specialtext
  },
  props: {
    isBotTest: { type: Boolean, default: false },
    ntn_message: [Object, String, Array],
    size: {
      type: String,
      default: 'big'
    },
    ratio: {
      default: 'square'
    }
  },
  data() {
    return {
      showCopy: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    onCopyError: function () {
      console.error('Error copying text')
    },
    btnClick(button) {
      this.$emit('clickBtnMessage', button.notification_messages_frequency)
    },
    onCopy: function () {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/NtnViewer.vue